export default "__VITE_ASSET__kjjWf6jR__"